<template>
  <div class="picker_footer"   v-if="visible">
    <div class="picker_footer_main" :class="visible ? 'fadeIn' : ''">
        <div class="picker_footer_nav_list">
            <div class="picker_footer_nav_item"  v-for="(item, index) in nav" :key="index" @click="choose(index)">{{item}}</div>
        </div>
        <div class="picker_footer_nav_list">
            <div class="picker_footer_nav_item" @click="cancel">取消</div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props:{
        visible:{
            type: Boolean,
            default: true,
        },
        nav:{
            type: Array,
            required: true,
        }
    },
    methods:{
        choose(index){
            this.$emit('choose', index)
            this.$emit('update:visible', false)
        },
        cancel(){
            this.$emit('cancel', 'cancel')
            this.$emit('update:visible', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.picker_footer{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:rgba(0,0,0,.6);
    z-index: 99;
    .picker_footer_main{
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 0 24px/$ppr;
        box-sizing: border-box;
    }
    .picker_footer_nav_list{
        margin: 16px/$ppr 0;
        border-radius: 20px/$ppr;
        overflow: hidden;
        &:first-child{
            border-top: 0;
        }
        .picker_footer_nav_item{
            border-top: 1px solid #eaeaea;
            background:#fff;
            padding: 26px/$ppr 20px/$ppr;
            text-align: center;
            color:#5e89ef;
            font-size: 32px/$ppr;
        }
    }
}
.fadeIn{
    animation: fadeIn linear 0.1s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
 
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

</style>